const STORAGE_KEY = 'sl-application-menu-state';

document.addEventListener('DOMContentLoaded', function () {
    const menuList = document.getElementById('menu-list');
    const menuRoot = document.getElementById('nova-menu-root');

    if (!menuList) return;

    const persistState = menuRoot && menuRoot.dataset.persistState === 'true';

    // Initial state is restored by an inline script in standard_sub_bs5.htm
    // (runs before first paint to avoid flicker)

    // Persist state after animation completes
    menuList.addEventListener('hidden.bs.collapse', function () {
        if (persistState) localStorage.setItem(STORAGE_KEY, 'hidden');
    });

    menuList.addEventListener('shown.bs.collapse', function () {
        if (persistState) localStorage.setItem(STORAGE_KEY, 'not-hidden');
    });
});
